import { AppShell, MantineProvider, useMantineTheme } from '@mantine/core';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';
import {
  Devices,
  FileReport,
  Forms,
  History,
  Home,
  LetterB,
  LetterM,
  LetterP,
  LetterR,
  Link,
  ReceiptRefund,
  Users,
} from 'tabler-icons-react';
import { NavLinkType } from '../../type/navlink.types';
import AppHeader from './header/header.component';
import AppSidebar from './sidebar/sidebar.component';

const PartnerDashboardLayout = () => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const navLinkProps: NavLinkType[] = [
    {
      order: 1,
      link: '/partner/dashboard',
      label: 'Dashboard',
      icon: Home,
    },
    {
      order: 2,
      link: '/partner/partners',
      label: 'Partners',
      icon: LetterP,
    },
    {
      order: 3,
      link: '/partner/resellers',
      label: 'Resellers',
      icon: LetterR,
    },
    {
      order: 4,
      link: '/partner/merchants',
      label: 'Merchants',
      icon: LetterM,
    },
    {
      order: 5,
      link: '/partner/branches',
      label: 'Branches',
      icon: LetterB,
    },
    {
      order: 6,
      link: '/partner/create-payment-links',
      label: 'Payment Links',
      icon: Link,
    },
    {
      order: 7,
      link: '/partner/transactions',
      label: 'Transactions',
      icon: FileReport,
    },
    {
      order: 8,
      link: '/partner/logs',
      label: 'Logs',
      icon: History,
    },
    {
      order: 9,
      link: '/partner/users',
      label: 'User Management',
      icon: Users,
    },
    {
      order: 10,
      sublinks: [
        { link: 'partner/mids', label: 'View All MIDs' },
        { link: '/partner/mids/add', label: 'Create MID' },
      ],
      link: '',
      label: 'MID',
      icon: Forms,
    },
    {
      order: 11,
      sublinks: [
        { link: 'partner/pos', label: 'View All POSs' },
        {
          link: '/partner/pos/create',
          label: 'Create POS',
        },
      ],
      link: '',
      label: 'POS',
      icon: Devices,
    },
  ];

  return (
    <>
      <Helmet>
        <title>XPAY.World - Partner Dashboard</title>
      </Helmet>
      <MantineProvider withGlobalStyles withNormalizeCSS>
        <AppShell
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#ffffff',
              '@media (max-width: 992px)': {
                paddingLeft: 'calc(var(--mantine-aside-width, 0px) + 16px)',
              },
            },
          }}
          navbarOffsetBreakpoint='md'
          asideOffsetBreakpoint='md'
          fixed
          navbar={<AppSidebar navLinkProps={navLinkProps} opened={opened} />}
          header={<AppHeader opened={opened} setOpened={setOpened} />}
        >
          <Outlet />
        </AppShell>
      </MantineProvider>
    </>
  );
};

export default PartnerDashboardLayout;
